// Formatage FR (règle globale : dates, nombres et montants au format français partout).

// Montant en devise, format français : "1 234,56 €".
// Retourne null si la valeur n'est pas un nombre exploitable (le composant gère alors le repli, ex. "-").
export function formatEUR(value, currency = 'EUR') {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  const cur = /^[A-Za-z]{3}$/.test(String(currency)) ? String(currency).toUpperCase() : 'EUR';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency', currency: cur,
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(n);
}

// Nombre simple au format français : "1 234,5".
export function formatNumberFR(value, maxDecimals = 2) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: maxDecimals }).format(n);
}
